import { decryptPaymentParams } from './crypto';
import type { PaymentParams } from './types';

/**
 * Parse and decrypt the payment parameters: ?data=<encrypted>&iv=<iv>
 * Returns null if they are missing, tampered with, or incomplete.
 */
export async function parsePaymentParams(): Promise<PaymentParams | null> {
  const params = new URLSearchParams(window.location.search);
  const encryptedData = params.get('data');
  const iv = params.get('iv');

  if (!(encryptedData && iv)) {
    return null;
  }

  try {
    return await decryptPaymentParams(encryptedData, iv);
  } catch (_error) {
    return null;
  }
}

/**
 * Show error message in UI
 */
export function showError(message: string): void {
  const loadingEl = document.getElementById('loading');
  const errorEl = document.getElementById('error');
  const errorMessageEl = document.getElementById('error-message');

  if (loadingEl) loadingEl.classList.add('hidden');
  if (errorEl) errorEl.classList.remove('hidden');
  if (errorMessageEl) errorMessageEl.textContent = message;
}
